import React from 'react';
import useMetaTags from '../../hooks/useMetaTags';
// import Services_we_offer from '../../component/Services_Component/Services_we_offer';
import { AssistanceSection, BenefitSection, BoostSection, CustomSection, FAQ, LargeData, ServicesSection, roleWriting } from '../../Data/All_Services_Data/contentMarketingData';
import Custom_section from '../../component/Services_Component/Custom_services_section';
import Benefits_section from '../../component/Services_Component/Benefits_section';
import Boost_section from '../../component/Services_Component/Boost_section';
import Assistance_section from '../../component/Services_Component/Assistance_section';
import FAQ_section from '../../component/Services_Component/FAQ_section';
import Role_writing from '../../component/Services_Component/Role_writing';
import Handle_Largedata_section from "../../component/Services_Component/Handle_Largedata_section";

const ContentWriting = () => {
    useMetaTags({
      title: "Expert Content Marketing Services for Your Business Needs",
      description:
        "Professional content marketing services to grow your business. Receive top-tier, tactical content that attracts traffic, generates brand awareness, and increases conversions",
      keywords:
        "content marketing services, content strategy framework, content marketing services, content in marketing, content writing agency, copywriting agency, content marketing services, Email Marketing Content Writing, Social Media Content Writing, SEO Content Writing, Content Optimization",
    });
    return (
      <>
        <section
          className=""
          style={{
            backgroundImage: `url('assets/img/service/serviceD.jpg')`,
            backgroundPosition: "center",
            backgroundSize: "cover",
          }}
          id="service-sec"
        >
          <div className="round-container pt-5">
            <div className="container">
              <div className="title-area text-center">
                <span className="sub-title text-white">OUR SERVICES</span>
                <h1 className="sec-title text-white">
                  We Are a Content Marketing Services for Powerful Engagement
                </h1>
              </div>
            </div>
          </div>
        </section>
        <section className="space-extra-bottom">
          <div className="page-single">
            <div className="page-content">
              <style>{`
                    .header-section{
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 30px;
        }
        .header-section img{
            height: 400px;
        }
        .header-section p{
            text-align: left;
        }

        @media only screen and (max-width: 990px) {
        .header-section{
            flex-direction: column;
        }
        .header-section img{
            height: 200px;
        }
            .header-section p{
            text-align: center;
        }
        }
                `}</style>
              {/* Intro part  */}
              <div
                className="header-section container"
                style={{ marginTop: "20px" }}
              >
                <img
                  src="assets/img/icon/content.avif"
                  loading="lazy"
                  alt="heading_image"
                />
                <div>
                  <p>
                    We are a custom content marketing services focused on creating
                    powerful results-oriented engagement. At Warrgyizmorsch, we
                    believe that compelling content is the first brick of a
                    brand's visibility, audience trust, and business expansion.
                    Our approach on meaningful content is rooted in audience
                    content marketing services resonance and business
                    compatibility. We combine creativity, strategy, and
                    analytics to ensure that every single word delivers value
                    for the client. Our content marketing strategies aim to
                    build awareness, drive sales, and secure retention in a way
                    that is tailored to you. Let us tell your story with
                    cementing connections.
                  </p>
                </div>
              </div>
              {/* Warrgyizmorsch's Content Marketing Services  */}
              {/* <Services_we_offer data={ServicesSection} /> */}
              <Handle_Largedata_section LargeData={LargeData} />

              {/* The Importance of Content Marketing for Your Business */}
              <Custom_section data={CustomSection} />
              {/* <Custom_section data={CustomSection} /> */}

              {/* Warrgyizmorsch Content Strategy Framework  */}
              <Benefits_section data={BenefitSection} />

              {/* Role of writing  */}
              <Role_writing data={roleWriting} />

              {/* Grow your business  */}
              <Boost_section data={BoostSection} />

              {/* Hire Content Marketing Agency  */}
              <Assistance_section data={AssistanceSection} />

              {/* FAQ section  */}
              <FAQ_section data={FAQ} />
            </div>
          </div>
        </section>
        <div className="scroll-top">
          <svg
            className="progress-circle svg-content"
            width="100%"
            height="100%"
            viewBox="-1 -1 102 102"
          >
            <path
              d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
              style={{
                transition: "stroke-dashoffset 10ms linear 0s",
                strokeDasharray: "307.919, 307.919",
                strokeDashoffset: "307.919",
              }}
            ></path>
          </svg>
        </div>
      </>
    );
};

export default ContentWriting;